import React from 'react';
import './CourseLiveInfo.less';
import Picture from '../../../../components/picture/Picture';
import { getJumpLink } from '../../../../lib/utils/UtilsCommon';

/**
 * 可选参数
 */
interface IProps {
	liveInfo: any;
}

/**
 * CourseLiveInfo
 */
class CourseLiveInfo extends React.PureComponent<IProps> {
	/**
	 * render
	 */
	public render(): any {
		const { liveInfo } = this.props;
		const liveEntity: any = liveInfo.entity || {};

		return liveInfo ? (
			<div className="p-course-live-info">
				<a href={getJumpLink('live', liveEntity.id)}>
					<div className="flex ai-center">
						<Picture placeholder src={liveEntity.logo} className="live-poster" />
						<p className="elli">{liveEntity.name}</p>
					</div>
				</a>
				<p className="live-ext">
					<span>话题&nbsp;{liveInfo.allTopicNum}</span>
					{/* <span>粉丝&nbsp;{liveEntity.fansNum}</span> */}
				</p>
			</div>
		) : null;
	}
}

export default CourseLiveInfo;
